import React, { FunctionComponent } from 'react';

import { Advantage } from '@domains/advantage';

import { applyTypograf } from '@utils/typograf';

import { Picture } from '@components/common/Picture/Picture';
import { WysiwygPresenter } from '@components/common/WysiwygPresenter/WysiwygPresenter';

import styles from './AdvantageCard.module.scss';

export const AdvantageCard: FunctionComponent<Advantage> = (props) => {
    const { image, name, short_description } = props;

    return (
        <article className={styles.root}>
            <div className={styles.grid}>
                <Picture
                    sources={image}
                    alt={name}
                    className={styles.image}
                    classes={{ picture: styles.picture }}
                />

                <div className={styles.column}>
                    <h5 className={styles.title} dangerouslySetInnerHTML={{ __html: name }}></h5>
                    {short_description !== null && (
                        <WysiwygPresenter
                            content={applyTypograf(short_description)}
                            className={styles.text}
                        />
                    )}
                </div>
            </div>
        </article>
    );
};
